import { StyleSheet } from "react-native";
import hashify from "glamor/lib/hash";

export const css = (o: any) => {
  const hash = hashify(o);
  let sheet = StyleSheet.create({ [hash]: o });
  return sheet[hash];
  // you'd also memoize this function on hash/ident/etc
};
